import { Injectable } from '@angular/core';

import { ConfigurationsService, ConfigurationType } from '@icc/configurator/shared';
import { map } from 'rxjs/operators';

@Injectable()
export class AccessoryFacade {

    accessories$ = this.configurationsService.configuration$.pipe(map(conf => 'Accessories' in conf && conf.Accessories || []));

    constructor(
        protected configurationsService: ConfigurationsService<ConfigurationType>
    ) {}

}
